export const STATUSES = [
  { key: "nuovo", label: "Nuovo", dot: "bg-cobalt", chip: "border-cobalt text-cobalt" },
  { key: "contattato", label: "Contattato", dot: "bg-terracotta", chip: "border-terracotta text-terracotta" },
  { key: "confermato", label: "Confermato", dot: "bg-emerald-500", chip: "border-emerald-500 text-emerald-600" },
  { key: "annullato", label: "Annullato", dot: "bg-ink/30", chip: "border-ink/30 text-ink/50" },
];

export const statusMeta = (key) => STATUSES.find((s) => s.key === key) || STATUSES[0];

export const fmtDate = (iso) =>
  iso
    ? new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "2-digit", hour: "2-digit", minute: "2-digit" })
    : "—";
